// Adaptador concreto del repositorio de información inicial (capa HTTP).
// Por ahora combina los catálogos existentes (marcas, años, ciudades).
// TODO: reemplazar por el endpoint único de datos iniciales cuando el backend lo exponga.
import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin, map } from 'rxjs';
import { InitialDataRepository } from '../../../domain/repositories/initial-data/initial-data.repository';
import {
  City,
  InitialDataResponse,
  VehicleBrand,
} from '../../../domain/interfaces/initial-data/initial-data.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

/**
 * Implementación del repositorio de datos iniciales
 * Usa el InitialDataService para obtener los datos del API
 */
@Injectable()
export class InitialDataRepositoryImplementation extends InitialDataRepository {
  private readonly http = inject(HttpClientService);

  override getAllInitialData(): Observable<InitialDataResponse> {
    return forkJoin({
      brands: this.http
        .get<VehicleBrand[]>(API_ENDPOINTS.vehicles.brands)
        .pipe(map((res) => res.data)),
      years: this.http
        .get<number[]>(API_ENDPOINTS.vehicles.years)
        .pipe(map((res) => res.data)),
      cities: this.http
        .get<City[]>(API_ENDPOINTS.cities.list)
        .pipe(map((res) => res.data)),
    });
  }
}
